import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Skeleton } from "primereact/skeleton";
import { toast } from "react-toastify";
//pages
import { LaunchCommissionHeader } from "./LaunchCommissionHeader";
import { TableCommission } from "./TableCommission";
//services
import { getCommissions } from "../../services/Commissions/getCommissions";
import { useOptionsSelect } from "../../hooks/useOptionsSelect";
import { useFinancialContext } from "../../context/FinancialContext";
//components
import Select from "../../components/input/Select";
import Panel from "../../components/panel/panel";
import CalendarInput from "../../components/input/CalendarInput";
import { Button } from "primereact/button";
//utils
import { formatYearDate } from "../../utils/formatDate";
import { Pagination } from "react-bootstrap";

export function LaunchCommission() {
  const form = useForm();
  const errors = form.formState.errors;
  const [dataTable, setDataTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const { control, watch } = useForm();
  const { enterprise, isLoadingEnterprises, selectEnterprise } =
    useOptionsSelect();
  const { filter, setFilter, savedDataTable, setSavedDataTable } =
    useFinancialContext();

  const optionCurrent = [
    { value: 0, label: "Pendente" },
    { value: 1, label: "Lançada" },
    { value: 2, label: "Recusada" },
  ];

  const onSubmit = async (data) => {
    console.log("Filtros antes da requisição:", data);
    setLoading(true);

    // Remove status se for "all"
    if (data.status === "all") delete data.status;

    // Formata datas
    if (data.start_date && data.end_date) {
      data.start_date = formatYearDate(data.start_date);
      data.end_date = formatYearDate(data.end_date);
    }

    // Remove campos vazios
    const cleanedData = {};
    for (let key in data) {
      if (data[key] !== undefined && data[key] !== "") {
        cleanedData[key] = data[key];
      }
    }

    console.log("Filtros limpos enviados para API:", cleanedData);

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );

    setFilter(cleanedData);

    try {
      // Agora chamamos a API passando os filtros corretamente
      const response = await getCommissions(data);
      console.log("Resposta da API:", response);

      setDataTable(response);

      const total = response.last_page * response.per_page;
      setTotalRecords(total);
      setCurrentPage(response.current_page);
      setFirst(0);
      setRows(response.per_page);

      if (!response || response.length === 0) {
        toast.update(notification, {
          render: "Nenhum resultado para a consulta realizada",
          type: "warning",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
        setDataTable([]); // Garante que a tabela seja esvaziada caso não haja resultados
      } else {
        toast.update(notification, {
          render: "Consulta realizada com sucesso",
          type: "success",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
      }
    } catch (error) {
      toast.update(notification, {
        render: "Falha ao realizar consulta!",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      console.error("Erro na consulta:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter) {
      form.setValue("enterprise_id", filter?.enterprise_id);
      form.setValue("status", filter?.status);
      form.setValue("start_date", filter?.start_date);
      form.setValue("end_date", filter?.end_date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="row d-flex justify-content-center">
      <LaunchCommissionHeader />
      <div className="col-md-12"></div>

      <>
        <Panel title="Informe o Período">
          <form
            className="row d-flex mt-4"
            onSubmit={form.handleSubmit(onSubmit)}
          >
            <div className="col-md-3 mb-3 form-group">
              <Select
                name="enterprise_id"
                label={
                  isLoadingEnterprises ? "Carregando..." : "Empreendimento*"
                }
                control={form.control}
                preValue={filter?.enterprise_id}
                disabled={isLoadingEnterprises}
                isRequired={true}
                onChange={(e) => selectEnterprise(e)}
                options={enterprise}
                errors={errors}
              />
            </div>

            <div className="col-md-3 mb-3 form-group">
              <Select
                name="status"
                label="Situação"
                preValue={filter?.status}
                control={form.control}
                options={optionCurrent}
                errors={errors}
              />
            </div>

            <div className="col-md-3 mb-3 form-group">
              <CalendarInput
                name="start_date"
                control={form.control}
                errors={errors}
                label="Data início"
              />
            </div>
            <div className="col-md-3 mb-3 form-group">
              <CalendarInput
                name="end_date"
                control={form.control}
                errors={errors}
                label="Data Fim"
              />
            </div>
            <div className="d-flex justify-content-end my-2">
              <div
                className={`${
                  window.innerWidth <= 992 ? "w-25" : "col-md-1"
                } text-center`}
              >
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </form>
        </Panel>
        {dataTable?.length > 0 && (
          <>
            <TableCommission
              dataTable={dataTable}
              // totalRecords={dataTable.length}
              isLoading={isLoading}
            />
            <Pagination
              first={first}
              rows={rows}
              // totalRecords={totalRecords}
              // onPageChange={handlePageChange}
              template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            />
          </>
        )}
      </>
    </div>
  );
}
